import { OrderInfo } from "../../order-info/order-info.model";
import { Authorizations } from "../authorization/authorization.model";
import { Records } from "../records/records.model";
import { Subjects } from "../subjects/subjects.model";
import { DefendantCounsel, PlaintiffCounsel } from "../subpoena/subpoena.model";
import { DocumentReference } from "./record-index-table/record-index-table.component"

export interface Contact {
    displayName: string,
    phone: number,
    extension: string,
    email: string,
    title: string,
    barNumber: string
}

export interface BillingInfo {
    email: string,
    billTo: string
}

export interface AdjusterInfo {
    email: string,
    adjusterName: string;
}

export interface DeliveryInfo {
    attentionTo: string,
    firmTo: string,
    phone: string,
    extension: string,
    address: string
}

export interface AttachmentInfo {
    storageId: string,
    storageProviderId: string,
    contentType: string,
    fileName: string,
    displayName: string,
    description: string,
    sizeBytes: number,
    sizeText: string
}

export interface Subject {
    name: string,
    alias: string,
    dateOfBirth: string,
    lastDigitOfSSN: string,
    dateOfDeath: string,
    requestNumbers: string[]
}

export interface CounselInfo {
    recordSubjectName: string,
    attorneyName: string,
    firmName: string,
    address: string,
    phone: string,
    extension: string,
    fax: string,
    email: string
}

export interface Defendant {
    name: string,
    address: string
}

export interface Subpoena {
    counselInfo: PlaintiffCounsel[],
    defendant: DefendantCounsel[],
    judge: string,
    court: string,
    courtAddress: string,
    jurisdictionCounty: string,
    state: string,
    caseNumber: string,
    caseName: string,
}

// record types infrfaces
export interface Ambulance {
    date: string,
    time: string,
    pickupAddress: string,
    dropAddress: string
}

export interface DiagnosticImages {
    type: string,
    others: string,
    specificBodyPart: string
}

export interface Employment {
    ss: string
}
export interface Insurance {
    claimNumber: string,
    policyNumber: string
}
// same as emplyment
export interface IRS {
    ss: string
}
export interface Military {
    branch: string,
    serviceNumber: string
}
export interface SocialSecurity {
    ss: string,
    address: string
}
export interface Union {
    membershipNumber: string
}
export interface VA {
    va: string
}
export interface Other {
    descriptionOfRecords: string
}
export interface Provider {
    provider: string,
    doctor: string,
    address: string,
    email: string,
    phone: string,
    extn: string,
    fax: string,
    recordSubject: string,
    recordRange: string,
    recordType: string,
    subpoenaLanguage: string,
    notes: string,
    ambulance: Ambulance,
    imaging: DiagnosticImages,
    employment: Employment,
    insurance: Insurance,
    irs: IRS,
    military: Military,
    socialSecurity: SocialSecurity,
    union: Union,
    va: VA,
    other: Other
}

export interface Plaintiff {
    name: string;
    streetAddress: string;
    city: string;
    state: State;
    zip: string;
    value: string;
    keys?: any;
}

export interface RecordSubjectName {
    name: string;
    value: string;
    keys?: any;
}

export interface State {
    name: string;
    value: string;
}

export interface Order {
    orderInfo?: OrderInfo;
    subjects?: Subjects;
    subpoena?: Subpoena;
    authorization?: Authorizations;
    records?: Records;
}

export class OrderDetails {
    id: string = "";
    claimNumber: string = "";
    dateOfIncident: string = "";
    carrierName: string = "";
    typeOfOrder: string = "";
    serviceLevel: string = "";
    orderedDate: string = "";
    orderStatus: string = "";
    clientActionRequired: boolean = false;
    caseMatter?: string;
    contacts: Contact[] = [
        // {
        //     contactName: 'loream ipsum 1 nsns sjsnsns snsnnss snnsnsns snsnss snsns snsnsns snss snssns',
        //     phone: 7863833676,
        //     email: 'loream@example.com',
        //     title: 'loream ipsum',
        //     barNumber: '1234'
        // },
        // {
        //     contactName: 'loream ipsum 1',
        //     phone: 7863833676,
        //     email: 'loream@example.com',
        //     title: 'loream ipsum',
        //     barNumber: ''
        // }
    ];
    billingInfo: BillingInfo = {
        email: '',
        billTo: '',
    };
    adjusterInfo:AdjusterInfo = {
        adjusterName: '',
        email: ''
    };
    deliveryInfo: DeliveryInfo = {
        attentionTo: "",
        firmTo: "",
        phone: '',
        extension: "",
        address: ""
    };
    specialInstructions: string = "";
    subjects: Subject[] = [
        // {
        //     name: "loream ipsum",
        //     alias: "loream ipsum",
        //     dateOfBirth: "26/02/2025",
        //     lastDigitOfSSN: '1234',
        //     dateOfDeath: "26/02/3000"
        // }, 
        // {
        //     name: "loream ipsum",
        //     alias: "loream",
        //     dateOfBirth: "26/02/2025",
        //     lastDigitOfSSN: '1234',
        //     dateOfDeath: ""
        // }
    ];
    counselInfo: PlaintiffCounsel[] = [
        // {
        //     recordSubjectName: "loream ipsum",
        //     attorneyName: "loream ipsum",
        //     firmName: "ipsum",
        //     address: " loream ipsum",
        //     phone: "25363636363",
        //     fax: "loream ipsum",
        //     email: "ipsum@gmail.com"
        // },
        // {
        //     recordSubjectName: "loream ipsum",
        //     attorneyName: "loream ipsum",
        //     firmName: "ipsum",
        //     address: " loream ipsum",
        //     phone: "25363636363",
        //     fax: "loream ipsum",
        //     email: "ipsum@gmail.com"
        // }
    ];
    caseNumber: string = '';
    subpoena: Subpoena = {
        counselInfo: [
            // {
            //     recordSubjectName: "",
            //     attorneyName: "",
            //     firmName: "",
            //     address: "",
            //     phone: "",
            //     fax: "",
            //     email: ""
            // }
        ],
        defendant: [
            // {
            //     name: "loream ipsum",
            //     address: "loream ipsum"
            // },
            // {
            //     name: "loream ipsum",
            //     address: "loream ipsum"
            // }
        ],
        judge: "",
        court: "",
        courtAddress: "",
        jurisdictionCounty: "",
        state: "",
        caseNumber: "",
        caseName: ""
    };
    providers: Map<string, Provider> = new Map();
        // {
        //     provider: "loream ipsum",
        //     doctor: "loream ipsum",
        //     address: "loream ipsum",
        //     email: "loreamipsum@gmail.com",
        //     recordSubject: "loream ipsum",
        //     recordRange: "loream ipsum",
        //     recordType: "Medical, Billing, Ambulance, Diagnostic Images",
        //     subpoenaLanguage: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
        //     notes: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
        //     ambulance: {
        //         date: "26/7/2010",
        //         time: "5.50 PM",
        //         pickupAddress: "loram ipsum",
        //         dropAddress: "loram ipsum"
        //     },
        //     imaging: {
        //         type: "X-rays, CT-scan",
        //         others: "loream ipsum",
        //         specificBodyPart: "loream ipsum"
        //     },
        //     employment: {
        //         ss: "loream ipsum"
        //     },
        //     insurance: {
        //         claimNumber: "loream ipsum",
        //         policyNumber: "loream ipsum"
        //     },
        //     irs: {
        //         ss: "loream ipsum"
        //     },
        //     military: {
        //         branch: "loream ipsum",
        //         serviceNumber: "loream ipsum"
        //     },
        //     socialSecurity: {
        //         ss: "loream ipsum",
        //         address: "loream ipsum"
        //     },
        //     union: {
        //         membershipNumber: "loream ipsum"
        //     },
        //     va: {
        //         va: "loream ipsum"
        //     },
        //     other: {
        //         descriptionOfRecords: "loream ipsum"
        //     }
        // },
    //];
    attachmentInfo: DocumentReference[] = [
        // {
        //     storageId: "",
        //     storageProviderId: "",
        //     contentType: "",
        //     fileName: "",
        //     displayName: "",
        //     description: ""
        // }
    ];
    accountName: string = "";
    orderOwner: string = "";
    createdBy?: string = "";
}

